<template>
  <fts-client-modal
    append-content-class="list-view-preference-modal__body"
    title="User Preference"
    class="fts-list-view-preference-modal"
    ref="ftsClientModal"
  >
    <!-- header:icon -->
    <i slot="icon" class="fts-icon-cog" />
    <!-- body -->
    <template #body>
      <draggable
        v-bind="dragOptions"
        handle=".preference-column-handle"
        :list="formData"
      >
        <div
          class="preference-column"
          v-for="column in formData"
          :key="column.id"
        >
          <font-awesome-icon
            :icon="['fas', 'grip-vertical']"
            class="preference-column-handle"
          />
          <div class="preference-column-information">
            <i
              class="preference-column-information-icon"
              :class="[
                getIcon(column && column.type),
                { 'system-default': column.system },
              ]"
            />
            <div class="preference-column-information-name">
              {{column.displayName}}
            </div>
          </div>
          <div class="preference-column-action">
             <fts-toggle-switch
                :form-data="column"
                :item="{ fieldName: 'show' }"
                :label="false"
                mat-class
                :size="14"
              />
          </div>
        </div>
      </draggable>  
    </template>
    <!-- footer:left -->
    <template #footerLeft>
      <fts-btn text @click="resetUserPreference">
        <font-awesome-icon :icon="['fas', 'redo-alt']" /> Reset
      </fts-btn>
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <fts-btn text @click="beforeClose">
        <font-awesome-icon :icon="['fas', 'times']" /> Close
      </fts-btn>

      <fts-btn color="primary" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-client-modal>
</template>

<script>
import changesets from "diff-json";
import draggable from "vuedraggable";

import commons from "../commons/commons";

import FTSClientModal from './FTSClientModal';
import FTSBtn from "./FTSBtn";
import FTSToggleSwitch from "./FTSToggleSwitch";

export default {
  components: {
    draggable,
    "fts-client-modal": FTSClientModal,
    "fts-btn": FTSBtn,
    "fts-toggle-switch": FTSToggleSwitch,
  },
  data: () => ({
    formData: null,
    originalData: null,
    resolve: null,
    dragOptions: commons.dragOptions,
  }),
  methods: {
    async show(items) {
      this.formData = _.cloneDeep(items);

      this.formData.forEach((x) => {
        if (x["show"] === null || x["show"] === undefined)
          this.$set(x, "show", true);
      });

      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsClientModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) { 
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    },
                  },
                ],
              });
            } else {
              this.reset();
            }
          },
        });

        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    done() {
      this.resolve && this.resolve(this.formData);
      this.reset();
    },
    beforeClose() {
      this.$refs.ftsClientModal.beforeClose();
    },
    reset() {
      this.$refs.ftsClientModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    getIcon(typeId) {
      return commons.informationIcon(typeId);
    },
    resetUserPreference() {
      this.resolve && this.resolve(null);
      this.reset();
    },
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-list-view-preference-modal {
  .list-view-preference-modal__body {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .preference-column {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .75rem 1.75rem;
    &:hover {
      background: var(--fts-gray-1);
      .preference-column-handle {
        display: block;
      }
    }
    .preference-column-handle {
      position: absolute;
      left: .575rem;
      display: none;
      font-size: .75rem;
      color: var(--fts-gray-5);
      cursor: grab;
    }
    .preference-column-information {
      min-width: 0;
      display: flex;
      align-items: center;
      .preference-column-information-icon {
        margin-right: .575rem;
        color: $secondaryColor;
        &.system-default {
          color: $primaryColor;
        }
      }
      .preference-column-information-name {
        @include text-overflow-ellipsis;
        font-size: 1rem;
        color: var(--fts-text);
      }
    }
    .preference-column-action {
      margin-left: .75rem;
    }
  }
}
</style>